import React, {useState} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import TextfieldAtom from '../textfield/textfield.atom'
import ButtonAtom from '../button/button.atom'

const validationSchema = Yup.object({
  personName: Yup.string()
    .min(2, 'Please enter a name more than 1 character')
    .required('This field is required'),
})

const FormAtom = function ({...props}) {
  const [finalValue, setFinalValue] = useState<{personName: string}>()
  const {handleSubmit, handleChange, values, errors} = useFormik({
    initialValues: {
      personName: '',
    },
    validationSchema,
    onSubmit: () => {
      setFinalValue(values)
    },
  })
  return (
    <form onSubmit={handleSubmit}>
      {props.children}
      <div>
        <TextfieldAtom
          label="Person Name"
          name="personName"
          value={values.personName}
          error={!!errors.personName}
          helperText={errors.personName ? errors.personName : null}
          onChange={handleChange}
        />
      </div>
      <div>
        <ButtonAtom type="submit" ap_type="secondary">
          Submit
        </ButtonAtom>
      </div>
      <div>{finalValue?.personName}</div>
    </form>
  )
}
export default FormAtom
